<!--临时客商新增  -->
<template>
	<div class="info-box">
		<el-dialog title="路线信息"
			v-if="dialogVisible"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			width="1000px"
			:before-close="cancle"
			top="3vh">
			<div class="info-title flex flex-between">
				<div class="lh30">基础信息:</div>
			</div>
			<!-- 基础信息 -->
			<div class="form-box mt15">
				<el-form label-position="right" :inline="true" size="small" :model="ruleForm" :rules="rules"
					ref="ruleForm" label-width="100px">
					<el-form-item label="路线名称" prop="routeName">
						<el-input v-model="ruleForm.routeName" class="w190" maxlength="20"></el-input>
					</el-form-item>
					<el-form-item label="组织结构" prop="groupId">
						<el-select v-model="ruleForm.groupId" class="w190" size="small" placeholder="选择" disabled>
							<el-option v-for="item in groupList" :key="item.groupId" :label="item.groupName"
								:value="String(item.groupId)">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="配送车辆" prop="licensePlate">
						<el-input v-model="ruleForm.licensePlate" class="w190" maxlength="16" readonly
							 :disabled="ruleForm.groupId?false:true">
							<i slot="suffix" :class="!ruleForm.groupId?'nonallowed':''" @click="handleCar" class="el-input__icon el-icon-search"></i>
						</el-input>
					</el-form-item>
					<el-form-item label="启用状态" prop="routeStatus">
						<el-select v-model="ruleForm.routeStatus" class="w190" size="small" placeholder="选择">
							<el-option label="正常" value="Y">
							</el-option>
							<el-option label="停用" value="N">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="主路线员" prop="mainUserCode">
						<el-input v-model="ruleForm.mainUserCode" class="w190" maxlength="16" readonly
							 :disabled="ruleForm.groupId?false:true">
							<i slot="suffix" :class="!ruleForm.groupId?'nonallowed':''" @click="handleRouteUser(1)" class="el-input__icon el-icon-search"></i>
						</el-input>
					</el-form-item>
					<el-form-item label="副路线员">
						<el-input v-model="ruleForm.secUserCode" class="w190" maxlength="16" readonly
							 :disabled="ruleForm.groupId?false:true"
							>
							<i slot="suffix" :class="!ruleForm.groupId?'nonallowed':''" @click="handleRouteUser(2)" class="el-input__icon el-icon-search"></i>
							<i slot="suffix" v-if="ruleForm.secUserCode" @click="handleClear" class="el-input__icon el-icon-circle-close"></i>
						</el-input>
					</el-form-item>
					<el-form-item label="主路线员名">
						<el-input v-model="ruleForm.mainUserName" class="w190" maxlength="16" readonly></el-input>
					</el-form-item>
					<el-form-item label="副路线员名">
						<el-input v-model="ruleForm.secUserName" class="w190" maxlength="16" readonly></el-input>
					</el-form-item>
					<el-form-item label="路线类型" prop="routeType">
						<el-select v-model="ruleForm.routeType" class="w190" size="small" placeholder="选择">
							<el-option label="单人" value="1"></el-option>
							<el-option label="双人" value="2"></el-option>
							<el-option label="Min" value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="销售据点分类">
						<el-select v-model="ruleForm.routeTag1" class="w190" size="small" placeholder="选择">
							<el-option label="分公司" value="分公司"></el-option>
							<el-option label="外仓" value="外仓"></el-option>
							<el-option label="营业所" value="营业所"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="标签3">
						<el-input v-model="ruleForm.routeTag3" class="w190"></el-input>
					</el-form-item>
				</el-form>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>
		<addCar ref="addCar" @selectCarRows="selectCarRows"></addCar>
		<addRouteUser ref="addRouteUser" @selectUserRows="selectUserRows" @flag="flag" @clearReadonly="clearReadonly"></addRouteUser>
	</div>
</template>

<script>
	import { debounce } from '@/utils/debounce'
	import addCar from '../../route/components/add-car.vue'
	import addRouteUser from '../../route/components/add-route-user.vue'
	export default {
		components: {
			addCar,
			addRouteUser
		},
		data() {
			return {
				dialogVisible: false,
				groupList: [],
				ruleForm: {
					routeCode: '',
					routeId: "",
					routeName: "",
					groupId: "",
					licensePlate: "",
					routeStatus: "Y",
					mainUserCode: "",
					secUserCode: "",
					mainUserName: "",
					secUserName: "",
					carId: "",
					routeType: "",
					routeTag1: "",
					routeTag2: "",
					routeTag3: "",
				},
				rules: {
					routeName: [{
						required: true,
						message: '请输入路线名称',
						trigger: 'blur'
					}, ],
					groupId: [{
						required: true,
						message: '请选择组织结构',
						trigger: 'change'
					}, ],
					licensePlate: [{
						required: true,
						message: '请选择配送车辆',
						trigger: 'change'
					}],
					routeStatus: [{
						required: true,
						message: '请选择启用状态',
						trigger: 'change'
					}, ],
					mainUserCode: [{
						required: true,
						message: '请选择主路线员',
						trigger: 'change'
					}, ],
					routeType: [{
						required: true,
						message: '请选择路线类型',
						trigger: 'change'
					}, ],
				},
				flagRow: [],
				secFlag: true,
				selectUserId:{
					mainUserId:"",
					secUserId:"",
				},
				// 圈选agent列表
				agentList: []
			}
		},
		created() {

		},
		methods: {
			init(agentList, groupId) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.getBusSelectList()
					this.ruleForm = {
						routeId: "",
						routeName: "",
						groupId: "",
						licensePlate: "",
						routeStatus: "Y",
						mainUserCode: "",
						secUserCode: "",
						mainUserName: "",
						secUserName: "",
						carId: "",
						routeType: "",
						routeTag1: '',
						routeTag2: '',
						routeTag3: ''
					}
					this.selectUserId={
						mainUserId:"",
						secUserId:"",
					}
					this.ruleForm.groupId = String(groupId);
					this.agentList = agentList;
				})
			},
			// 选择的车辆信息
			selectCarRows(val) {
				this.ruleForm.licensePlate = val[0].licensePlate
				this.ruleForm.carId = val[0].carId
			},
			//  添加线路员类型
			flag(val) {
				if (val == 1) {
					this.ruleForm.mainUserCode = this.flagRow[0].datas[1]
					this.ruleForm.mainUserName = this.flagRow[0].datas[0]
					this.selectUserId.mainUserId = this.flagRow[0].dataKey

				} else {
					this.ruleForm.secUserCode = this.flagRow[0].datas[1]
					this.ruleForm.secUserName = this.flagRow[0].datas[0]
					this.selectUserId.secUserId = this.flagRow[0].dataKey
				}
			},
			// 添加线路员
			selectUserRows(val) {
				this.flagRow = val
			},
			// 清除副路线员readonly状态
			clearReadonly() {
				this.secFlag = false;
			},
			//添加线路成员
			handleRouteUser(val) {
				if(val == 2) {
					this.secFlag = true;
				}
				this.$refs.addRouteUser.init(val, this.selectUserId,this.ruleForm.groupId)
			},
			// 清除副路线员
			handleClear() {
				this.secFlag = true;
				this.ruleForm.secUserCode = '';
				this.ruleForm.secUserName = '';
			},
			// 添加车辆
			handleCar() {
				this.$refs.addCar.init(this.ruleForm)
			},
			// 组织部门
			getBusSelectList() {
				let that = this;
				that.$request.post(
						"busSelectList",
						false, {}
					)
					.then((res) => {
						if (res) {
							that.groupList = res.data
						}
					})
			},
			// 保存
			submitForm: debounce(function () {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						if (this.ruleForm.mainUserCode == this.ruleForm.secUserCode) {
							this.$message.error('主路线员和副路线员不能一致!');
							return
						}
						this.$confirm('是否确认保存？', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(() => {
							this.addRoute()
						}).catch(() => {});
					} else {
						return false;
					}
				});
			}, 1000, true),
			// 新增
			addRoute() {
				let changeAgents = [];
				for (const agent of this.agentList) {
					changeAgents.push({
						routeId: agent.routeId ? agent.routeId : 0,
						agentId: agent.agentId
					});
				}
				let that = this;
				that.$request.post(
						"routeMapChangeAgent",
						true, {
							groupId: that.ruleForm.groupId,
							routeName: that.ruleForm.routeName,
							licensePlate: that.ruleForm.licensePlate,
							routeStatus: that.ruleForm.routeStatus,
							mainUserCode: that.ruleForm.mainUserCode,
							secUserCode: that.ruleForm.secUserCode,
							mainUserName: that.ruleForm.mainUserName,
							secUserName: that.ruleForm.secUserName,
							carId: that.ruleForm.carId,
							routeType: that.ruleForm.routeType,
							changeAgents: changeAgents,
							routeTag1: that.ruleForm.routeTag1,
							routeTag2: that.ruleForm.routeTag2,
							routeTag3: that.ruleForm.routeTag3
						}
					)
					.then((res) => {
						if (res) {
							that.$message.success("保存成功！");
							that.$emit('handleClose');
							this.$emit("changeRoute");
							that.dialogVisible = false
						}
					})
			},
			// 取消
			cancle() {
				this.dialogVisible = false
				this.$refs['ruleForm'].resetFields();
				this.$emit("getList")
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.mb0 {
		margin-bottom: 0 !important;
	}

	.w90 {
		width: 110px;
	}

	.nc-box {
		padding: 10px;
		border-bottom: 1px solid #DCDFE6;
		color: #606266;
		font-size: 13px;
	}

	.mb10 {
		margin-bottom: 10px !important;
	}

	.w190 {
		width: 280px !important;
	}

	.info-box {
		/deep/ .el-dialog__body {
			padding: 0 5px 20px;
			overflow-y: auto;
		}
	}

	.info-title {
		background: #E5E5E5;
		color: #333;
		padding: 10px;
		box-sizing: border-box;
		font-size: 16px;
		font-weight: bold;

		img {
			vertical-align: bottom;
			display: block;
		}
	}

	.el-form-item {
		width: 420px;
	}

	.w330 {
		width: 330px;
	}

	.w420 {
		width: 420px !important;
		margin-right: 10px;
	}

	.info-name {
		display: inline-block;
		width: 140px;
		text-align: right;
	}

	.opeartion {
		font-size: 18px;
		cursor: pointer;
	}

	.lh30 {
		line-height: 30px;
	}

	.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 5px;
		}

		/deep/ td {
			padding: 5px;
		}

	}
.el-icon-search{
	cursor: pointer;
}
.el-icon-circle-close{
	cursor: pointer;
}
</style>
